import { ButtonTypes, ConfirmModal, type ModalButtonProps, ProgressBar } from "@clintonelec/react-storybook";
import { memo, useEffect, useState, type PropsWithChildren } from "react";
import "Components/ConfigLayout/System/ManagementSettings/ProgressBarModal/ProgressBarModal.less";

const confirmButton: ModalButtonProps = {
	text: "Confirm",
	type: ButtonTypes.TERTIARY
};

type ProgressBarModalProps = {
	inProgressMessage: string;
	completeMessage: string;
	title: string;
	totalDuration: number;
};

function ProgressBarModal(props: PropsWithChildren<ProgressBarModalProps>) {
	const { inProgressMessage, completeMessage, title, totalDuration, children } = props;
	const [ elapsedTime, setElapsedTime ] = useState(0);
	const [ completed, setCompleted ] = useState(false);
	const [ visible, setVisible ] = useState(false);
	const buttonDisabled = elapsedTime < totalDuration;

	useEffect(() => {
		if (elapsedTime >= totalDuration || !visible) {
			setCompleted(true);

			return;
		}

		const interval = setInterval(() => setElapsedTime(elapsedTime + 1), 1000);

		return () => clearInterval(interval);
	}, [ totalDuration, elapsedTime, visible ]);

	const progress = elapsedTime / totalDuration * 100;

	const handleVisibilityChange = (newVisibility: boolean) => {
		setElapsedTime(0);
		setCompleted(false);
		setVisible(newVisibility);
	};

	const message = completed ? completeMessage : inProgressMessage;
	const modalContent = (
		<div className="progress-bar-modal">
			<ProgressBar progress={ progress } showProgress={ false } />
			<span>{ message }</span>
		</div>
	);

	return (
		<ConfirmModal
			cancelButton={ { text: "" } }
			okButton={ { ...confirmButton, disabled: buttonDisabled } }
			title={ title }
			modalContent={ modalContent }
			onVisibilityChange={ handleVisibilityChange }
			visible={ visible }
		>
			{ children }
		</ConfirmModal>
	);
}

export default memo(ProgressBarModal);
